import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";
import { contains } from "@fluorescent/dom";

const selectors = {
  image: ".image, .placeholder-svg",
  animateBackground: ".animation--section-introduction-background",
  sectionIntro: ".animation--section-introduction > *",
  shoppableItems: ".shoppable-item",
};

export default node => {
  if (!shouldAnimate(node)) return;

  let animationItems = [
    selectors.animateBackground,
    selectors.sectionIntro,
    selectors.image,
    selectors.shoppableItems,
  ];

  if (contains(node, "shoppable-feature--align-left")) {
    animationItems = [
      selectors.image,
      selectors.animateBackground,
      selectors.sectionIntro,
      selectors.shoppableItems,
    ];
  }

  delayOffset(node, animationItems);

  const observer = intersectionWatcher(node, true);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
